if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        document.body.classList.remove('overflowhidden');
      }

      show(opener) {
        super.show(opener);
        console.log("Script running");
        document.body.classList.add("overflowhidden");


        const fullMediaId = window.lastViewedMediaId;
        if (!fullMediaId) return;

        const mediaId = fullMediaId.split("--").pop().split("__main-").pop();

        const $carousel = $(this.querySelector(".owl-carousel"));

        const interval = setInterval(() => {
          if (!$carousel.hasClass("owl-loaded")) return;

          const $items = $carousel.find(".owl-item [data-media-id]");
          let indexToSlide = 0;

          $items.each(function (index) {
            const modalMediaId = this.dataset.mediaId;
            if (modalMediaId === mediaId) {
              indexToSlide = index;
              return false;
            }
          });

          $carousel.trigger("to.owl.carousel", [indexToSlide, 0, false]);
          clearInterval(interval);
        }, 30);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
            "data-media-id"
          )}"])`
        ).forEach((element) => {
          element.classList.remove("active");
        });
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        );
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;
        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
      }
    }
  );
}
